/**
 * Behaviour for the `dubb-agent-header` Dubb Page element on the Dubb Agent layout
 * (the markup lives in the element, in the DB): the mobile drawer opens from the
 * burger and closes on the scrim, the close button, Escape, or growing to desktop;
 * open "Log in" menus close on an outside click or Escape.
 *
 * Returns a cleanup that removes every listener.
 */
export function initDubbAgentHeader(): () => void {
  const controller = new AbortController()
  const { signal } = controller
  const burger = document.querySelector<HTMLButtonElement>('.da-hd .da-hd-burger')
  const drawer = document.getElementById('da-drawer')
  const scrim = document.querySelector<HTMLElement>('.da-scrim')

  if (!burger || !drawer || !scrim)
    return () => controller.abort()

  const setOpen = (open: boolean): void => {
    if ((drawer.dataset.open === 'true') === open)
      return

    drawer.dataset.open = scrim.dataset.open = String(open)
    burger.setAttribute('aria-expanded', String(open))
    document.documentElement.style.overflow = open ? 'hidden' : ''
    ;(open ? drawer.querySelector<HTMLElement>('[data-da-drawer-close]') : burger)?.focus()
  }

  const closeLogins = (except: Node | null): void => {
    document.querySelectorAll<HTMLDetailsElement>('.da-login[open]').forEach((details) => {
      if (!details.contains(except))
        details.open = false
    })
  }

  burger.addEventListener('click', () => setOpen(true), { signal })
  document.querySelectorAll('[data-da-drawer-close]').forEach((el) => {
    el.addEventListener('click', () => setOpen(false), { signal })
  })
  document.addEventListener('click', e => closeLogins(e.target as Node), { signal })
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape')
      return

    closeLogins(null)
    setOpen(false)
  }, { signal })
  // Keep in sync with the 1023px header breakpoint in css/dubb-agent.css.
  window.matchMedia('(min-width: 1024px)').addEventListener('change', (e) => {
    if (e.matches)
      setOpen(false)
  }, { signal })

  return () => controller.abort()
}

initDubbAgentHeader()
